import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const ProfessionalNetworkScreen1: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        See all your professional relationships in one place. Spot gaps, invite
        new firms, and grow your network. It’s free for them to join when you
        invite.
      </p>
    }
  />
)

export default ProfessionalNetworkScreen1
